<div class="snackBarContainer" fxFlex fxLayout="column" fxLayoutGap="16px">
    <h5 class="white">
        {{ 'GENERIC.SNACKBAR.ORDER.PLACED' | translate }} 
    </h5>
    <div fxFlex fxLayout="row" fxLayoutGap="16px">
        <button  class="btn btn-primary" type="button" (click)="navigateToOrder()">{{ 'GENERIC.SNACKBAR.ORDER.GO.TO.ORDER' | translate }} </button>
        <button  class="btn btn-secondary border" type="button" (click)="dismiss()">{{ 'BTN.CLOSE' | translate }}</button>

    </div>
</div>